import React from 'react';
import { makeStyles } from '@material-ui/core';
import logoReverse from '../../themes/02_8-bar-reverse.svg';

const useStyles = makeStyles({
  img: {
    width: 90,
    height: 'auto',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return <img className={classes.img} src={logoReverse} alt="IBM" />;
};

export default LogoIcon;
